module.exports = __webpack_public_path__ + "img/human-icon.9cf3a588.png";